import React from 'react';
import PropTypes from 'prop-types';
import UserService from '../../../../../services/user.service';

const FeedbackSimple = ({
  item,
  vote,
  body,
  status,
  imgSrc,
  voteStatus,
  backgroundColor,
  voteForFeedback }) => (
    <div className="BlogsBox boxs BlogsBoxkb smpleBox2">
      <div className="left">
        <svg aria-hidden="true" focusable="false" style={{ width: 0, height: 0, position: 'absolute' }}>
          <linearGradient id="gradientfill" className={`emoj-list ${backgroundColor}`}>
            <stop offset="0%" stopColor="var(--color-stop-1)" />
            <stop offset="100%" stopColor="var(--color-stop-2)" />
          </linearGradient>
        </svg>
        <div className={`upvoteincdec boxs ${!voteStatus ? 'active' : ''} ${backgroundColor}`} data-id="1">
          <span
            className="downvoteimg  add pointer"
            id="add1"
            onClick={e => voteForFeedback(e, item.id, true)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.972 9.971" className="vote-arrow">
              <g id="Group_Copy_2" data-name="Group Copy 2" transform="rotate(0)">
                <path
                  id="Line_2"
                  d="M7.471 0L0 7.471"
                  className="cls-1"
                  stroke="#a8afb8"
                  data-name="Line 2"
                  transform="translate(8.195 .333)"
                />
                <path
                  id="Line_2_Copy"
                  d="M0 0l7.471 7.471"
                  className="cls-1"
                  stroke="#a8afb8"
                  data-name="Line 2 Copy"
                  transform="translate(.195 .333)"
                />
              </g>
            </svg>
          </span>
          <span
            className={`upvoteimg minus pointer emoj-list ${backgroundColor}`}
            id="minus1"
            onClick={e => voteForFeedback(e, item.id, false)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.972 9.971" className="vote-arrow">
              <g
                id="Group_Copy_2"
                data-name="Group Copy 2"
                transform="rotate(180 8.459 4.528)"
                stroke="none"
                strokeWidth="2"
                fill="none"
                fillRule="evenodd"
              >
                <path
                  id="Line_2"
                  d="M7.471 0L0 7.471"
                  className="cls-1"
                  data-name="Line 2"
                  transform="translate(8.195 .333)"
                />
                <path
                  id="Line_2_Copy"
                  d="M0 0l7.471 7.471"
                  className="cls-1"
                  data-name="Line 2 Copy"
                  transform="translate(.195 .333)"
                />
              </g>
            </svg>
          </span>
          <h6 className={`vote ${voteStatus ? 'tc thm-text' : ''}`}>{vote}</h6>
        </div>
      </div>
      <div className="right">
        <h5>{item.title}</h5>
        <p className="pre-line">{body}</p>
        <p>
          <span className={`fdbck-${item.status} fdbckfil`}>{status}</span>
          {item.creator_name && <span className="fedright">
            <img
              src={imgSrc}
              alt="feedbackimg"
              className="feedback-img"
              onError={(e) => { e.target.src = UserService.defaultAvatar; }}
            />
            <span>{item.creator_name}</span>
          </span>}
        </p>
      </div>
    </div>

);

FeedbackSimple.propTypes = {
  item: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  voteStatus: PropTypes.bool.isRequired,
  body: PropTypes.string,
  voteForFeedback: PropTypes.func.isRequired,
  vote: PropTypes.number,
  backgroundColor: PropTypes.string.isRequired,
};

export default FeedbackSimple;



// WEBPACK FOOTER //
// ./src/views/modules/feedback/feedbackItem/simple/FeedbackSimple.jsx